import { TeaBlocksError } from './../../TeaBlocksError';
import { ReturnBlock } from "../ReturnBlock";

/**
 * Block for retrieving a value of an array at a specific index.
 */
export class ArrayGetIndex extends ReturnBlock {
    index: ReturnBlock;
    arrName: string;

    /**
     * Constructor
     * @param id id of state node
     * @param arrName name of array
     * @param inputs index is inputs[0]
     */
    constructor(id: string, arrName: string, inputs: ReturnBlock[]) {
        super(id);
        this.arrName = arrName;
        this.index = inputs[0];
    }


    /**
     * Retrieves the value of the array at provided index.
     * @param varEnv variable environment
     */
    evalBlock(varEnv: Map<string, any>) {
        let arr = varEnv.get(this.arrName);
        if (arr == null) throw new TeaBlocksError('Array does not exist', this.id);

        let index = Number(this.index.evalBlock(varEnv));
        if (isNaN(index)) throw new TeaBlocksError('Index is not a number', this.id);

        let val = arr[index];

        if (val == null) throw new TeaBlocksError(`Nothing at index ${index}`, this.id);

        return val;
    }


}